import { Scene } from "phaser";

export class ErrorScene extends Scene {

    constructor() {
        super("ErrorScene");
    }

    init(data) {

        this.errorMessage  = data.message
        this.cameras.main.fadeIn(500, 0, 0, 0);
    
    }

    create() {

        this.errorMessageText = this.add.text(this.scale.width/2, this.scale.height/2, this.errorMessage, { fontFamily: 'Montserrat',
            fontSize: '30px',
            color: '#fff'
        }).setOrigin(0.5)
       
    }

    

}